import { createContext } from "react";

export type ContextMenuSlots = {
  actions: HTMLDivElement | null;
  options: HTMLDivElement | null;
};

export const ContextMenuSlotsContext = createContext<ContextMenuSlots>({
  actions: null,
  options: null,
});
